import Colors from '../constants/Colors';

const getPriorityColor = (priority: number) => {
  if (priority === 0) return Colors.light.hereworksRed500;
  if (priority === 1) return Colors.light.hereworksOrange500;
  if (priority === 2) return Colors.light.hereworksYellow500;
  if (priority === 3) return Colors.light.hereworksBlue500;
  if (priority === 4) return Colors.light.hereworksGreen500;
  return Colors.light.hereworksBlack600;
};

export default getPriorityColor;
